// extracted by mini-css-extract-plugin
export default {"div":"ExternalLink_div__OjWwe"};